import { render, staticRenderFns } from "./CategoriesIcon.vue?vue&type=template&id=0516bdf2&"
import script from "./CategoriesIcon.vue?vue&type=script&lang=ts&"
export * from "./CategoriesIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports